import Routes from '../../constants/routes';
import makeUrl from './make-url';

const getAuthorLink = (author: Author) =>
    makeUrl(Routes.AUTHOR_MAIN.pathByWorld(author?.details?.world), { id: author?.id, slug: author?.slug });

export default getAuthorLink;
